import { Download } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface Props {
  url: string
  filename?: string
}

export function DownloadButton({ url, filename }: Props) {
  return (
    <Button asChild variant="outline" size="sm">
      <a href={url} download={filename ?? true} target="_blank" rel="noreferrer">
        <Download className="h-4 w-4" /> Download
      </a>
    </Button>
  )
}
